import React from 'react';
import loader from '../../assets/icons/loader.svg';
import styles from './sass/Loader.module.scss';

const Loader = () => {
  return (
    <div className={styles.container}>
      <img src={loader} alt="loader" />
    </div>
  );
};

export default Loader;
